import { useTranslation } from "react-i18next";
export function EmptyRooms({ recent }: { recent: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto mt-[clamp(0.75rem,5vh,3.125rem)] mb-6 flex max-w-85 flex-col items-center text-center">
      <img
        src="/assets/empty-rooms-mascot.png"
        alt=""
        aria-hidden="true"
        className="mb-3 h-auto w-70 max-w-full"
        width={861}
        height={463}
      />
      <h2 className="my-2.5 font-heading text-base font-medium tracking-tight">
        {t(recent ? "home.emptyRecentTitle" : "home.emptyPublicTitle")}
      </h2>
      <p className="text-sm leading-loose text-muted-foreground">
        {t(recent ? "home.emptyRecentBody" : "home.emptyPublicBody")}
      </p>
    </div>
  );
}
